import {Component, Input, OnInit} from '@angular/core';
import { GlobalService } from '../../services/global.service';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication.service';
declare let moment: any;

@Component({
  selector: 'pages-top',
  templateUrl: './pages-top.component.html',
  styleUrls: ['./pages-top.component.scss'],
})
export class PagesTopComponent implements OnInit {

  avatarImgSrc: string = 'assets/images/logo-single.png';
  userName: string = 'Grand Silo Beja';
  userPost: Date;
  currentUser : any;
  ip : any;
  week: any;
  sidebarToggle: boolean = true;
  tip = { ring: true, email: true };

  constructor(private _globalService: GlobalService, private router: Router, private authenticationService : AuthenticationService) {
    let now = new Date();
    this.userPost = now;
  }

  public _sidebarToggle() {
    /* this._globalService.sidebarToggle$.subscribe(sidebarToggle => {
      this.sidebarToggle = sidebarToggle;
    }, error => {
      console.log('Error: ' + error);
    }); */

    this._globalService.data$.subscribe(data => {
      if (data.ev === 'sidebarToggle') {
        this.sidebarToggle = data.value;
      }
    }, error => {
      console.log('Error: ' + error);
    });
    this._globalService.dataBusChanged('sidebarToggle', !this.sidebarToggle);
    //this._globalService._sidebarToggleState(!this.sidebarToggle);
  }

  public logout(){
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!this.currentUser){
      this.router.navigate(['/login']);
    }
    this.ip = localStorage.getItem('ip');
    this.week = moment(new Date()).isoWeek();
  }

}
